
      import EmailLine from './email-line.vue'
      import type { App, Plugin } from 'vue'

      export const EmailLinePlugin: Plugin = {
        install(app: App) {
          app.component('EmailLine', EmailLine)
        },
      }
      export { EmailLine }
      